import { TextField } from "@mui/material";
import { Hint } from "@/HOC";
import { colorPrimary } from "@/constants/colors";
import { TCustomTextFieldProps } from "./CustomTextField.props";

const CustomTextField = ({ hint = "", hintPosition, ...props }: TCustomTextFieldProps): JSX.Element => {
	return (
		<Hint hint={hint} position={hintPosition} width="100%">
			<TextField
				{...props}
				InputProps={{
					...props.InputProps,
					sx: {
						height: 33,
						color: colorPrimary,
						fontFamily: "inherit",
						fontSize: 13,
						fontStyle: "inherit",
						lineHeight: "inherit",
						letterSpacing: "inherit",
						...props.InputProps?.style,
					},
				}}
				InputLabelProps={{
					...props.InputLabelProps,
					style: {
						fontSize: 13,
						...props.InputLabelProps?.style,
					},
				}}
				sx={{
					...props.sx,
					width: "100%",
					'.MuiInputLabel-root[data-shrink="false"]': { top: -8 }, // label in input
					".MuiInputBase-input.MuiOutlinedInput-input": { paddingBlock: 0 },
					".MuiOutlinedInput-root": {
						paddingTop: "7.16px !important",
						paddingBottom: "7.16px !important",
					},
					// '.Mui-focused.MuiInputLabel-root[data-shrink="true"]': { color: colorSecondary }, // label in border
					// ".Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: colorSecondary + "!important" }, // border
				}}
			/>
		</Hint>
	);
};

export default CustomTextField;
